import {
  resolveMaxFileSizeBytes,
  tooLargeMessage,
} from "../upload-limits";

export default function CollectionImageForm() {
  collectionImageFormInit();
}

function collectionImageFormInit() {
  const form = document.getElementById("collection-image-form");
  if (!form) return;

  const imageInput = document.getElementById("CollectionImage");
  const imageValidationMessage = document.querySelector(
    ".collection-detail__validation-message"
  );
  const externalTriggers = document.querySelectorAll(
    ".js-collection-image-trigger"
  );

  const validImageTypes = JSON.parse(imageInput.dataset.fileTypes);
  const validTypesMessage = imageInput.dataset.valFileType;

  // Rendered by CollectionImageForm.cshtml from the configured limit. See upload-limits.js.
  const maxFileSizeBytes = resolveMaxFileSizeBytes(imageInput.dataset.fileSize);

  const fileInputHandler = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isValidType = validImageTypes.some((type) =>
      file.name.toLowerCase().endsWith(type)
    );
    const isValidSize = file.size <= maxFileSizeBytes;

    if (isValidType && isValidSize) {
      form.submit();
      return;
    }

    /*
     * One message for the rule that actually failed, not both concatenated. The old behaviour
     * told a member with a valid-but-large JPG that their file type was unsupported as well,
     * which is both wrong and unfixable — T212719 criterion 2. The oversize message is the
     * server's own wording, generated from the same configured limit the server enforces.
     */
    const message = !isValidType
      ? validTypesMessage
      : tooLargeMessage(file.size, maxFileSizeBytes);

    if (imageValidationMessage) {
      imageValidationMessage.style.display = "block";
      imageValidationMessage.textContent = message;
    } else {
      console.error(message);
    }
  };

  if (imageInput) {
    imageInput.addEventListener("change", fileInputHandler);
  }

  externalTriggers?.forEach((trigger) => {
    trigger.addEventListener("click", onImageTriggerClick);
  });

  function onImageTriggerClick() {
    if (!imageInput) return;
    imageInput.click();
  }
}
